import React from "react";
import {Button, Checkbox, Form, Icon, Input, Modal, message} from "antd";
import {Link} from "react-router-dom";
import axios from "axios";
import ReactMarkdown from "react-markdown";
import CustomScrollbars from "util/CustomScrollbars";

import {connect} from "react-redux";
import {
  showAuthMessage,
  hideMessage,
  showAuthLoader,
  userFacebookSignIn,
  userGithubSignIn,
  userGoogleSignIn,
  userSignUp,
  userTwitterSignIn
} from "appRedux/actions/Auth";

import IntlMessages from "util/IntlMessages";
import CircularProgress from "components/CircularProgress/index";

const FormItem = Form.Item;

class SignUp extends React.Component {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      console.log("values", values);
      if (!err) {
        this.props.showAuthLoader();
        this.props.userSignUp(values);
      }
    });
  };

  constructor() {
    super();
    this.state = {
      email: 'demo@example.com',
      password: 'demo#123',
      modal: false
    }

    this.handleOk = this.handleOk.bind(this);
  }

  componentDidMount() {
    axios("https://raw.githubusercontent.com/Viatick-co/Terms-Condition-BMS/master/Terms%26Condition.md")
    .then((content) => {
      console.log('content', content);
      this.setState({
        tc: content.data
      });
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 100);
    }

    console.log('this.props', this.props);
    if (!prevProps.signedUpUser && this.props.signedUpUser) {
      console.log('this.props.signedUpUser', this.props.signedUpUser);
      this.props.history.push('/signin');
      message.success('You have signed up successfully with email ' + this.props.signedUpUser.email);
    }
  }

  handleOk() {
    this.setState({
      modal: false
    });
  }

  render() {
    const {getFieldDecorator} = this.props.form;
    const {showMessage, loader, alertMessage} = this.props;
    return (
      <div className="gx-app-login-wrap gx-bg-light-blue">
        <div className="gx-app-login-container">
          <div className="gx-app-login-main-content">
            <div className="gx-app-logo-content">
              <div style={{width: '100%', height: '100%', background: 'url("' + require("assets/images/remote-access-control.png") + '")',
              backgroundPosition: 'center', backgroundSize: 'contain', backgroundRepeat: 'no-repeat'}}></div>
            </div>
            <div className="gx-app-login-content">
              <Form onSubmit={this.handleSubmit} className="gx-signup-form gx-form-row0">
                <FormItem style={{textAlign: 'center'}}>
                  <div className="gx-app-logo">
                    <img alt="example" src={require("assets/images/bms.jpeg")}/>
                  </div>
                </FormItem>
                <FormItem style={{textAlign: 'center'}}>
                  <h2>Sign Up</h2>
                </FormItem>

                <FormItem>
                  {getFieldDecorator('username', {
                    rules: [{required: true, message: 'Please input your username!'}],
                  })(
                    <Input placeholder="Username"/>
                  )}
                </FormItem>

                <FormItem>
                  {getFieldDecorator('email', {
                    rules: [{
                      required: true, type: 'email', message: 'The input is not valid E-mail!',
                    }],
                  })(
                    <Input placeholder="Email"/>
                  )}
                </FormItem>
                <FormItem>
                  {getFieldDecorator('password', {
                    rules: [{required: true,
                        message: 'Please input your Password!'
                      },
                      {min: 8,
                        message: 'Password must be at least 8 characters'
                      }
                    ],
                  })(
                    <Input type="password" placeholder="Password"/>
                  )}
                </FormItem>
                <FormItem style={{lineHeight: 2, fontSize: '9pt'}}>
                  {getFieldDecorator('remember', {
                    valuePropName: 'checked',
                    initialValue: false,
                    rules: [{
                      required: true,
                      transform: value => (value || undefined),  // Those two lines
                      type: 'boolean',                           // Do the magic
                      message: 'Please agree the terms and conditions.',
                    }],
                  })(
                    <Checkbox style={{fontSize: '9pt'}}><IntlMessages id="appModule.iAccept"/></Checkbox>
                  )}
                  <span style={{fontSize: '9pt'}} onClick={(e) => this.setState({modal: true})} className="gx-link gx-signup-form-forgot"><IntlMessages
                    id="appModule.termAndCondition"/></span>
                </FormItem>
                <FormItem style={{textAlign: 'center'}}>
                  <Button style={{
                    boxShadow: '0 2px 0 2px rgba(0, 0, 0, 0.2)',
                    borderRadius: '10px',
                    minWidth: '80px'
                  }} type="primary" className="gx-mb-0" htmlType="submit">
                    Create Account
                  </Button>
                </FormItem>
                <FormItem style={{textAlign: 'center'}}>
                  <span style={{fontSize: '12px'}}>Already have a BMS account ? </span><Link style={{fontSize: '12px'}} to="/signin">Sign In</Link>
                </FormItem>
              </Form>
            </div>
            {loader &&
            <div className="gx-loader-view">
              <CircularProgress/>
            </div>
            }
            {showMessage &&
            message.error("Fails to sign up with the provided credentials")}
          </div>
        </div>

        <Modal
          visible={this.state.modal}
          title="Terms & Conditions"
          onOk={this.handleOk}
          onCancel={this.handleOk}
          footer={[
          ]}
        >
        <CustomScrollbars style={{height: '400px'}}>
          {this.state.tc && <ReactMarkdown source={this.state.tc} />}
        </CustomScrollbars>
        </Modal>
      </div>
    );
  }

}

const WrappedSignUpForm = Form.create()(SignUp);

const mapStateToProps = ({auth}) => {
  const {loader, alertMessage, showMessage, signedUpUser} = auth;
  return {loader, alertMessage, showMessage, signedUpUser}
};

export default connect(mapStateToProps, {
  userSignUp,
  showAuthMessage,
  hideMessage,
  showAuthLoader,
  userFacebookSignIn,
  userGoogleSignIn,
  userGithubSignIn,
  userTwitterSignIn
})(WrappedSignUpForm);
